import _PlayArrow from "@mui/icons-material/PlayArrow";
import _Pause from "@mui/icons-material/Pause";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useEffect, useMemo, useState } from 'react';
import { ButtonContainer, DEFAULT_ICON_STYLES } from 'app/components/tv/customControls/SharedCustomControlsStyles';
export const PlaybackToggle = _ref => {
  let {
    playerRef,
    playerReady,
    adPlaying,
    isBigPlayButton = false,
    show = true,
    invert = false,
    ...props
  } = _ref;
  const [paused, setPaused] = useState(true);

  // fix play-state if play-event does not fire after ad
  useEffect(() => {
    const player = playerRef.current;
    if (!player || !playerReady) {
      return;
    }
    if (adPlaying) {
      return;
    }
    if (player.paused()) {
      return;
    }
    setPaused(false);
  }, [adPlaying, playerReady]);
  useEffect(() => {
    const player = playerRef.current;
    if (!player || !playerReady) {
      return;
    }
    const onPlay = () => {
      setPaused(false);
    };
    const onPause = () => {
      setPaused(true);
    };
    player.on('play', onPlay);
    player.on('pause', onPause);
    return () => {
      if (player) {
        player.off('play', onPlay);
        player.off('pause', onPause);
      }
    };
  }, [playerReady]);
  const handlePlaybackState = async () => {
    const player = playerRef.current;
    if (!player || !playerReady) {
      return;
    }
    if (player.paused()) {
      try {
        await player.play();
        setPaused(false);
      } catch (e) {
        setPaused(true);
      }
    } else {
      player.pause();
      setPaused(true);
    }
  };
  const iconStyles = useMemo(() => ({
    ...DEFAULT_ICON_STYLES,
    fontSize: isBigPlayButton ? '2em' : '1em'
  }), [isBigPlayButton]);
  const pauseIcon = /*#__PURE__*/React.createElement(_Pause, {
    style: iconStyles
  });
  const playIcon = /*#__PURE__*/React.createElement(_PlayArrow, {
    style: iconStyles
  });
  let icon;
  if (paused) {
    icon = invert ? pauseIcon : playIcon;
  } else {
    icon = invert ? playIcon : pauseIcon;
  }
  return /*#__PURE__*/React.createElement(ButtonContainer, _extends({
    onClick: handlePlaybackState,
    title: paused ? 'Abspielen' : 'Pausieren',
    dim: isBigPlayButton ? '3em' : '1em',
    show: show
  }, props, {
    "data-sentry-element": "ButtonContainer",
    "data-sentry-component": "PlaybackToggle",
    "data-sentry-source-file": "PlaybackToggle.tsx"
  }), icon);
};